module.exports = __webpack_public_path__ + "img/inactive.5845059a.svg";